/** Labels and listing helpers for copying parent L1 forms/attachments onto an L1.5. */
export const COPIED_FROM_L1_PREFIX = 'Copied from L1:';
export function stripWcFormTitlePrefix(title) {
    return (title ?? '').replace(/^WC[_:\s]+/i, '').trim();
}
export function copiedFromL1Label(original, fallback = 'Form') {
    const stripped = stripWcFormTitlePrefix(original);
    if (!stripped)
        return `${COPIED_FROM_L1_PREFIX} ${fallback}`;
    if (stripped.toLowerCase().startsWith(COPIED_FROM_L1_PREFIX.toLowerCase())) {
        return stripped;
    }
    return `${COPIED_FROM_L1_PREFIX} ${stripped}`;
}
function asRecord(value) {
    return value && typeof value === 'object' && !Array.isArray(value) ? value : {};
}
function surveyTitle(survey) {
    return typeof survey.title === 'string' ? survey.title : '';
}
export function answeredFieldCount(formData) {
    if (!formData)
        return 0;
    const seen = new Set();
    for (const [key, value] of Object.entries(formData)) {
        if (value == null || value === '' || (Array.isArray(value) && value.length === 0))
            continue;
        seen.add(key.includes('.') ? key.slice(key.lastIndexOf('.') + 1) : key);
    }
    return seen.size;
}
function toCopyFormItem(form, key, source, fallbackId) {
    const survey = asRecord(form.survey ?? undefined);
    const formData = asRecord(form.formData ?? undefined);
    const id = typeof form.id === 'number' && Number.isFinite(form.id) ? form.id : fallbackId;
    const title = form.formTitle?.trim() || surveyTitle(survey) || `Form ${id}`;
    if (answeredFieldCount(formData) === 0)
        return null;
    return {
        key,
        id,
        formId: typeof form.formId === 'number' && Number.isFinite(form.formId) ? form.formId : null,
        title,
        source,
        survey,
        formData,
    };
}
/** Same set as the parent Forms grid: issue forms plus task attached forms. */
export function collectParentCopyForms(detail) {
    const items = [];
    let fallback = -1;
    for (const form of detail.issueForms ?? []) {
        const item = toCopyFormItem(form, `issue-${form.id ?? fallback}`, 'L1 Form', fallback--);
        if (item)
            items.push(item);
    }
    for (const task of detail.tasks ?? []) {
        const taskId = typeof task.id === 'number' ? task.id : 0;
        const source = task.description?.trim() || (taskId ? `Task ${taskId}` : 'Task Form');
        for (const form of task.attachedForms ?? []) {
            const item = toCopyFormItem(form, `task-${taskId}-${form.id ?? fallback}`, source, fallback--);
            if (item)
                items.push(item);
        }
    }
    return items;
}
